import { createManagedWorker } from 'app/modules/wallforming/components/workers/createWorkerSingleton';
import { default as PanelDimensioningWorker } from 'app/modules/wallforming/components/workers/panelDimensioning.worker?worker';

import type { Point3D } from 'api/models';

export interface WorkerDimensionPanel {
    center: Point3D;
    width: number;
    height: number;
    text: string;
    fontSize: number;
    maxWidth: number;
    groupId: string | null;
}

interface ColliderPoint {
    poiGuids: string[];
    relationId: string;
    position: Point3D;
}

export interface PanelDimensioningWorkerInput {
    colliders: ColliderPoint[];
    selectedPoiIndex: number;
    mid: Point3D;
    planeNormal: Point3D;
    floorZ: number;
    groupIdByRelationId: Record<string, string>;
    poiGuids: Set<string>;
}

export interface PanelDimensioningWorkerResult {
    panels: WorkerDimensionPanel[];
}

const panelDimensioningWorker = createManagedWorker(() => new PanelDimensioningWorker());

export const acquirePanelDimensioningWorker = (): Worker => panelDimensioningWorker.acquire();
export const releasePanelDimensioningWorker = (): void => panelDimensioningWorker.release();
